exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-slick-border-hover[data-v-1fbe37fe]{border:none}.custom-slick-border-hover[data-v-1fbe37fe]:hover{border:solid;border-width:1px!important}", ""]);

// exports
